import { notification } from 'antd';
import { BusinessOffersService } from '@/modules/offer/services/business-offers.service';
import { DiContainer } from '@/modules/di/di-container';
import { BestPriceBuyerItem, IBestPriceBagItem } from '@/modules/mixing/store/analytical-mixing.store';
import { BusinessOfferActionType } from '@/modules/offer/types/business-offer';
import { indicateWheatType } from '../helpers/wheat-type.helper';
import { OFFER_ACTION_TYPE } from '../constants/trade-offers.constant';
import { fetchWarehousesForMixingDataFx } from '@/widgets/recipe/model';
import { debounce } from 'lodash-es';

const businessOffersService = DiContainer.get(BusinessOffersService);
export const createOfferFoo = async ({
  price,
  weight,
  sleeveData,
  onCancel,
  offer,
  warehouseId,
  additionalData,
  action,
  weight_gain_tons,
  initial_weight_gain_tons,
  signature,
}: IArgs) => {
  // if (!sleeveData.destination_id) {
  //   notification.warning({
  //     message: 'Ошибка',
  //     description:
  //       'в выбранном мешке отсутствует id логистического маршрута. Попробуйте, пожалуйста, позже',
  //   });
  // }
  try {
    const res: any = await businessOffersService.createBusinessOffer({
      weight_gain_tons: weight_gain_tons || 0,
      action,
      mix: false,
      mix_id: additionalData.mix_id,
      distance: offer.distance ? Number(offer.distance) : null,
      price_logistic: additionalData.price_logistic,
      initial_price_logistic: additionalData.initial_price_logistic,
      mixing_profit: additionalData.mixing_profit || 0,
      price_netto: additionalData.price_netto,
      price_all: additionalData.price_all,
      is_remnants: additionalData.is_remnants,
      warehouse_id: Number(warehouseId),
      destination_id: sleeveData.destination_id,
      price_id: sleeveData.price_id,
      company_name: offer.buyer,
      wheat_class: offer.class,
      wheat_type: String(indicateWheatType(sleeveData.sort, sleeveData.type)),
      initial_weight: null,//sleeveData.weight
      weight: weight ?? sleeveData.weight,
      initial_weight_gain_tons: initial_weight_gain_tons || 0,
      price: price ?? offer.price_per_ton,
      bags: {
        [sleeveData.id]: sleeveData.weight,
      },
      mix_signature: signature,
      action_place: additionalData.action_place,
      freight_cost_after_moisture_mod: sleeveData.freight_cost_after_moisture_mod || 0,
      freight_cost_before_moisture_mod: sleeveData.freight_cost_before_moisture_mod || 0,
      new_nature: sleeveData.new_nature,
      status: sleeveData.status,
    });
    if (res.id) {
      notification.success({ message: 'Сделка успешно создана' });
      return;
    }
    return notification.warning({
      message: 'Ошибка',
      description: 'при создании сделки возникла ошибка. Попробуйте позже',
    });
  } catch (err) {
    return notification.warning({
      message: 'Ошибка',
      description: 'при создании сделки возникла ошибка. Попробуйте позже',
    });
  } finally {
      onCancel();
      fetchWarehousesForMixingDataFx({} as any);
  }
};

interface IArgs {
  weight_gain_tons: number;
  initial_weight_gain_tons: number;
  action: BusinessOfferActionType;
  price: number;
  weight: number;
  warehouseId: number;
  onCancel: () => void;
  sleeveData: IBestPriceBagItem;
  offer: BestPriceBuyerItem;
  additionalData: {
    mix_id: number | null;
    mixing_profit: number | null;
    price_logistic: number;
    price_netto: number;
    price_all: number;
    is_remnants: boolean;
    action_place: OFFER_ACTION_TYPE | null;
    initial_price_logistic: number;
  },
  signature?: string;
  
  // wheat_type_n: number;
}

//export const createOfferFoo = debounce(createOfferFooBeforeDebounce, 500);
